module.exports = ".popup {\n  width: 320px;\n  max-width: 100%; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput,\n.btn {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  margin-top: 10px; }\n\n.route-label {\n  cursor: pointer; }\n\n.route-label * {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/message/message.component.scss
// module id = 909
// module chunks = 0